import { useEffect, useState } from 'react';

/** "mm:ss" (ou "h:mm:ss") desde o começo da caçada, como o protótipo: conta a cada segundo. */
export function tempoDesde(inicio: number, agora: number) {
  const s = Math.max(0, Math.floor((agora - inicio) / 1000));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), ss = s % 60;
  const dd = (n: number) => String(n).padStart(2, '0');
  return h ? `${h}:${dd(m)}:${dd(ss)}` : `${dd(m)}:${dd(ss)}`;
}

export function useTempoCacada(startedAt: string | null | undefined) {
  const inicio = startedAt ? Date.parse(startedAt) : NaN;
  const [agora, setAgora] = useState(() => Date.now());
  useEffect(() => {
    if (!Number.isFinite(inicio)) return;
    const id = window.setInterval(() => setAgora(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [inicio]);
  return Number.isFinite(inicio) ? tempoDesde(inicio, agora) : null;
}
